import { useState } from 'react';
import PropTypes from 'prop-types';
import IconButton from '../icon-button/IconButton';
import Clipboard from 'react-clipboard.js';
import classNames  from 'classnames';

import './CopyButton.scss';

const CopyButton = ({ data, icon, copyText = null, copiedText = null }) => {
    const [isCopied, setIsCopied] = useState(false);

    const copyClick = () => {
        setIsCopied(true);
        window.setTimeout(() => {
            setIsCopied(false);
        }, 1500);
    };

    const copyTextClasses = classNames({
        'disabled': isCopied
    }, 'copyText');

    return <Clipboard component="span" data-clipboard-text={data} className="copyToClipboard">
        <IconButton iconClass={`icon-${isCopied ? 'ok' : icon}`} onClick={() => copyClick()} isDisabled={isCopied}/>
        {copyText ? <span className={copyTextClasses} onClick={() => copyClick()}>{isCopied ? `(${copiedText})` : `(${copyText})`}</span> : null}
    </Clipboard>;
};

CopyButton.propTypes = {
    data: PropTypes.any.isRequired,
    icon: PropTypes.string.isRequired,
    copyText: PropTypes.bool,
    copiedText: PropTypes.string
};

export default CopyButton;
